import React, { useEffect, useRef } from "react";
import singleimg from "../../assets/images/img16.jpg";
import img from "../../assets/images/img4.jpg";
import avata1 from "../../assets/images/testi-img1.jpg";
import { Link } from "react-router-dom";
import ReactSpeedometer from "react-d3-speedometer"
import {
  FiMessageCircle,
  FiCheckCircle,
  FiChevronsLeft,
  FiChevronsRight,
  FiThumbsUp,
  FiMeh,
  FiChevronRight,
} from "react-icons/fi";
import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaGooglePlusG,
  FaReply,
  FaQuoteLeft,
} from "react-icons/fa";
import BlogSidebar from "./BlogSidebar";

const lists = [
  {
    list: "Sed do eiusmod tempor incididunt ut",
  },
  {
    list: "Exercitation ullamco laboris nis.",
  },
  {
    list: "Quis nostrud exer citation.",
  },
  {
    list: "Andomised words which don't look",
  },
  {
    list: "Commodo consequat duis autex.",
  },
  {
    list: "Andomised words which don't look",
  },
  {
    list: "Pharetra dui, nec tincidunt ante",
  },
];
export default function BlogDetailsContent({ blog, speedometerValue, customSegmentLabels ,segmentColors,isMobile}) {
  const speedometerRef = useRef(null);

  const getRiskLevelName = (value) => {
    if (value >= 850) return "Very High";
    if (value >= 600) return "High";
    if (value >= 400) return "Moderately High";
    if (value >= 200) return "Moderate";
    return "Low";
  };

  const riskLevel = getRiskLevelName(speedometerValue);
  const riskometerLabel = `Riskometer on ${riskLevel}`;

  useEffect(() => {
    if (speedometerRef.current) {
      const svg = speedometerRef.current.querySelector('svg.speedometer');
      if (svg) {
        svg.setAttribute('aria-label', riskometerLabel);
      }
    }
  }, [speedometerValue, riskometerLabel]);

  return (
    <section className="blog-details-wrapper">
      <div className="container">
        <div className="blog-details-grid d-grid">
          <div className="blog-details-left">
            <div className="blog-details-contents">
              <h2 style ={{font:"bold"}}>{blog.title}</h2>
              <div className="author-benchmark-container" style={{display:"flex", flexDirection: isMobile ? "column" : "row", width:"100%",height: isMobile ? "auto" : "90%",margin: isMobile ? "0" : "-10px"}}>
                <div className="author-container" style={{width: isMobile ? "100%" : "50%", margin: isMobile ? "10px 0" : "20px", justifyContent:"left"}}>
                  <p style={{ fontWeight: "bolder", color: "#233d63", margin: 0 }}>
                    {blog.author}
                  </p>
                  <p style={{ fontWeight: "bolder", color: "#233d63", margin: 0 }}>
                    {blog.benchmark}
                  </p>
                </div>
                <div className="speedometer-container" style={{width: isMobile ? "100%" : "auto"}} ref={speedometerRef}>
                  <ReactSpeedometer
                    width={270}
                    needleHeightRatio={0.7}
                    ringWidth={30}
                    textColor={'#033132'}
                    fontWeight={'2px'}
                    value={speedometerValue}
                    currentValueText="Riskometer"
                    customSegmentLabels={customSegmentLabels}
                    segmentColors={segmentColors}
                    needleTransitionDuration={2000}
                    segments={5}

                  />

                </div>
              </div>
              <p
                style={{
                  marginTop: isMobile ? "-15%" : "-135px",
                  maxWidth: "100%",
                  textAlign: "justify",
                }}
              >
                {blog.content}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}